import { Record } from 'immutable';
import { ActionTypes } from './types';
import {
  ICoterieState,
  ISetEndorsementEligibility,
  ISetEndorsementSelection,
  ISetPaymentOption,
  ISetPurchasedPolicyDetails,
  ISetSelectedQuote,
  PaymentOptions,
} from './interface';
import { getStore } from '../../utils/persist';

type Actions =
  | ISetSelectedQuote
  | ISetPaymentOption
  | ISetPurchasedPolicyDetails
  | ISetEndorsementEligibility
  | ISetEndorsementSelection;

const persistedStore = getStore();

const record = Record<ICoterieState>({
  selectedQuote: persistedStore?.coterie?.selectedQuote || null,
  paymentOption: persistedStore?.coterie?.paymentOption || PaymentOptions.Monthly,
  purchasedPolicyDetails: persistedStore?.coterie?.purchasedPolicyDetails || null,
  endorsementEligibility: persistedStore?.coterie?.endorsementEligibility || null,
  endorsementSelection: persistedStore?.coterie?.endorsementSelection || {},
});

class CoterieState extends record implements ICoterieState {}

export default function reducer(state = new CoterieState(), action: Actions) {
  switch (action.type) {
    case ActionTypes.SetSelectedQuote: {
      return state.set('selectedQuote', action.payload.selectedQuote);
    }

    case ActionTypes.SetPurchasedPolicyDetails: {
      return state.set('purchasedPolicyDetails', action.payload.purchasedPolicyDetails);
    }

    case ActionTypes.SetPaymentOption: {
      return state.set('paymentOption', action.payload.paymentOption);
    }

    case ActionTypes.SetEndorsementEligibility: {
      return state.set('endorsementEligibility', action.payload.endorsementEligibility);
    }

    case ActionTypes.SetEndorsementSelection: {
      return state.set('endorsementSelection', action.payload.endorsementSelection);
    }

    default: {
      return state;
    }
  }
}
